import { mapState } from 'vuex'
import { setDYcontext, dispatchDYcontext, dispatchDYready, clearDYcontext } from '@/modules/services/dy'
import { notifyBugsnag } from '@/modules/services/bugsnag'
import { pushDataLayerEvent } from '@/modules/services/gtm'

const dyUtil = {
  computed: {
    ...mapState({
      routerNavigation: state => state.layout.routerNavigation
    })
  },

  methods: {
    dispatchDYready,

    initDY (type, data, originalEntityType = 'OTHER') {
      if (originalEntityType === 'brands') {
        clearDYcontext()
      } else {
        if (this.routerNavigation) {
          dispatchDYcontext(type, { data })
        } else {
          setDYcontext(type, { data })
        }
      }
      this.dispatchDYready()
    }
  }
}

const dyProductBindings = {
  computed: {
    isMobile: () => vueSupport.isMobile
  },

  methods: {
    async dyAddToBagBinding (event) {
      // binds to third party (DY) product card
      const target = event.target

      if (!target.classList.contains('add_to_bag_text')) {
        return
      }

      const variantId = target.dataset['variantId'] || target.dataset['variant_id']
      const originalText = target.textContent
      target.textContent = target.dataset['disableWith'] || target.dataset['disable_with']

      try {
        await this.$store.dispatch('addToBag', {
          variantId,
          quantity: 1
        })
        try {
          dataLayer[0].cart.products.push({
            variant_id: parseInt(variantId),
            quantity: 1,
            currency: I18n.currency
          })
          pushDataLayerEvent('Add to Cart', {
            variant_id: variantId,
            quantity: 1
          })
        } catch (error) {
          notifyBugsnag(error)
        }

        if (this.isMobile) {
          this.$store.commit('setNotification', {
            msg: this.$t('notifications.addedToBag'),
            link: {
              path: '/cart',
              text: this.$t('notifications.viewBagCheckout')
            }
          })
        }
      } catch (error) {
        this.$store.commit('setNotification', {
          type: 'error',
          msg: this.$t('notifications.error')
        })
        notifyBugsnag(error)
      }
      target.textContent = originalText
    }
  }
}

export { dyUtil, dyProductBindings }
